import axios from "axios";
import CripNotice from "crip-vue-notice";
import router from "./router";
import store from './store';

// // production addr
//export const productionAddr = "https://prod-api.stockants.com/api";
//export const serverHostName = "https://prod-api.stockants.com";

// // // staging addr
export const productionAddr = "https://uat-api.stockants.com/api";
export const serverHostName = "https://uat-api.stockants.com"; 

export const serverAddr = axios.create({
  baseURL: productionAddr,
  timeout: 300000,
  headers: {},
  withCredentials: true, //
  transformRequest: [
    function(data, headers) {
      // Do whatever you want to transform the data
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        // data.token = access_token;
        headers["Authorization"] = "Bearer " + access_token;
      }
      headers["Content-Type"] = "application/json;charset=UTF-8";
      return JSON.stringify(data);
    },
  ],

  transformResponse: [
    function(data) {
      data = JSON.parse(data);
      if (!data.status && data.redirect) {
        console.log("failed to get access token");
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });

        var profile = null;
        var currentEnvironment = null;
        if (localStorage.getItem("profile")) {
          profile = JSON.parse(localStorage.getItem("profile"));
          store.commit("resetAllState");
          localStorage.clear();
          router.push({ path: data.redirect });
        } else {
          store.commit("resetAllState");
          localStorage.clear();
          router.push({ path: data.redirect });
        }

        return;
      }

      if ("token_data" in data) {
        // delete serverAddr.defaults.headers['access-token'];
        window.localStorage.setItem(
          "token",
          data["token_data"]["access_token"]
        );
        window.localStorage.setItem(
          "refresh_token",
          data["token_data"]["refresh_token"]
        );

        if ("expire_in" in data) {
          window.localStorage.setItem("expire_in", data["expire_in"]);
        }
      }

      if (!data.status && data.validation) {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }
      return data;
    },
  ],
});

serverAddr.interceptors.request.use(async (req) => {
  let expires_in = window.localStorage.getItem("expire_in");
  const is_expired = new Date() > new Date(expires_in);

  if (!is_expired || !expires_in) return req;

  if (window.localStorage.getItem("refresh_token") || expires_in) {
    console.log("token time expired");

    return axios
      .post(`${productionAddr}/auth/v1/obtain_access_token`, {
        refresh_token: window.localStorage.getItem("refresh_token"),
      })
      .then(function(response) {
        if (response.status == 200 && "token_data" in response.data) {
          window.localStorage.setItem(
            "token",
            response.data["token_data"]["access_token"]
          );

          if ("expire_in" in response.data) {
            window.localStorage.setItem(
              "expire_in",
              response.data["expire_in"]
            );
          }

          req.headers["Authorization"] =
            "Bearer " + response.data["token_data"]["access_token"];

          return req;
        } else {
          console.log("failed to get access token");
          var profile = null;
          var currentEnvironment = null;

          if (localStorage.getItem("profile")) {
            profile = JSON.parse(localStorage.getItem("profile"));
            store.commit("resetAllState");
            localStorage.clear();
            router.push({ path: data.redirect });
          } else {
            store.commit("resetAllState");
            localStorage.clear();
            router.push({ path: data.redirect });
          }
        }
      })
      .catch(function(err) {});
  }
});

export const serverAddrToUploadMediaFiles = axios.create({
  baseURL: productionAddr,
  timeout: 30000,
  headers: {},
  withCredentials: true,
  transformRequest: [
    function(data, headers) {
      // Do whatever you want to transform the data
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        // data.token = access_token;
        headers["Authorization"] = "Bearer " + access_token;
      }

      headers["Content-Type"] = "multipart/form-data;";
      // return JSON.stringify(data);
      return data;
    },
  ],

  transformResponse: [
    function(data) {
      data = JSON.parse(data);
      if ("token" in data) {
        // delete serverAddr.defaults.headers['access-token'];
        window.localStorage.setItem("token", data["token"]);
      }
      if (!data.status && data.validation) {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }
      return data;
    },
  ],
});

export const serverAddrForCSV = axios.create({
  baseURL: productionAddr,
  timeout: 30000,
  headers: {},
  withCredentials: true,
  transformRequest: [
    function(data, headers) {
      // Do whatever you want to transform the data
      const access_token = window.localStorage.getItem("token");
      if (access_token) {
        // data.token = access_token;
        headers["Authorization"] = "Bearer " + access_token;
      }

      headers["Content-Type"] = "application/json;charset=UTF-8";

      return JSON.stringify(data);
      // return data;
    },
  ],
  transformResponse: [
    function(data) {
      data = data;
      if (!data.status && data.validation) {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: data.validation,
          type: "error",
          duration: 3,
        });
      }
      return data;
    },
  ],
});
